import { To } from 'react-router-dom';

export function chartNavigation(
  chartSource: { title: string; value: string },
  navigate: (path: To, query?: {}) => void
) {
  if (chartSource.value) navigate(chartSource.value);
}
